import { PrimaryLinkButton } from '../../../components/buttons';
import { StepHeading } from './step-heading';

type SessionEndedProps = {
  storeId: string;
};

/**
 * Session-ended screen (spec §10 — open-tab stale-session handling).
 *
 * Shown when a backend action returns 404 or an unexpected terminal state
 * while the tab is still open (e.g. 24h TTL GC, lazy stale-fail, or another
 * tab's Abandon completing the session). Replaces a stale waiting/pause screen
 * whose buttons would fail mysteriously.
 */
export function SessionEnded({ storeId }: SessionEndedProps) {
  return (
    <div className="flex flex-col gap-4" data-testid="session-ended">
      <StepHeading>This receiving has ended.</StepHeading>
      <p className="text-base leading-relaxed text-gray-700">
        It may have been completed, abandoned, or cancelled from another tab or device.
      </p>
      <div className="mt-2 flex">
        <PrimaryLinkButton to="/stores/$storeId/receiving" params={{ storeId }}>
          Start a new receiving
        </PrimaryLinkButton>
      </div>
    </div>
  );
}
